import parseQueryStringCaseInsensitive from "@insite/client-framework/Common/Utilities/parseQueryStringCaseInsensitive";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderState, OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useContext } from "react";
import { shallowEqual, useSelector } from "react-redux";

const useOrder = (options?: Toolkit.GoogleAnalytics.Options) => {
    const { value: orderContext } = useContext(OrderStateContext);

    return useSelector((state: ApplicationState) => {
        if (options?.order) {
            return options.order;
        }

        if (orderContext) {
            return orderContext;
        }

        const { search } = getLocation(state);
        const { orderNumber } = parseQueryStringCaseInsensitive(search, { orderNumber: "" });

        return getOrderState(state, orderNumber).value;
    }, shallowEqual);
};

export default useOrder;
